/* istanbul ignore file */
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const store = () => ({
  selectedProduct: null,
  filters: null,
  loading: true,
  productsList: null,
  cloud: null,
});

export const useStore = create(devtools(store));
